module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/esPowerStance-82650de0a8f295f4044d086805341795.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/esPowerStance.png
// module id = 2487
// module chunks = 2